import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  ReadOutlined,
} from "@ant-design/icons"
import { Alert as AntAlert } from "antd"
import type { AlertProps as AntAlertProps } from "antd"
import styles from "./index.css"

export type AlertProps = AntAlertProps & {
  level?: "strong" | "default" | "weak"
  mode?: "notice" | "guide"
}

export const Alert = ({
  level = "default",
  mode = "notice",
  type,
  showIcon = true,
  icon,
  className,
  classNames,
  ...props
}: AlertProps) => {
  const tone =
    mode === "guide"
      ? "default"
      : type === "success"
        ? "success"
        : type === "error"
          ? "strong"
          : type === "info"
            ? "weak"
            : level
  const Icon =
    mode === "guide"
      ? ReadOutlined
      : tone === "weak"
        ? InfoCircleOutlined
        : tone === "success"
          ? CheckCircleFilled
          : ExclamationCircleFilled

  return (
    <AntAlert
      {...props}
      type={type ?? (level === "strong" ? "error" : "warning")}
      showIcon={showIcon}
      icon={icon ?? <Icon />}
      className={[
        styles.alert,
        styles[tone],
        (props.title ?? props.message) ? styles.withTitle : "",
        mode === "guide" ? styles.guide : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      classNames={(info) => {
        const classes =
          typeof classNames === "function" ? classNames(info) : classNames
        return {
          ...classes,
          icon: [styles.icon, classes?.icon].filter(Boolean).join(" "),
          section: [styles.section, classes?.section].filter(Boolean).join(" "),
          title: [styles.title, classes?.title].filter(Boolean).join(" "),
          description: [styles.description, classes?.description]
            .filter(Boolean)
            .join(" "),
          actions: [styles.actions, classes?.actions].filter(Boolean).join(" "),
        }
      }}
    />
  )
}
